import { Box, Typography, IconButton, Button } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useContext } from "react";
import { PersonalInformationContext } from "../../routes/PersonalInfo";
import OpsPanel from "../OpsPanel";
import drataIdentifierIconSVG from "../../img/icons/drata_identifier_icon.svg";
import NotificationService from "../../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/NotificationService";
import { DebounceButton } from "../../external/ensolvers-core-frontend-mui/components/Common/DebounceButton";
import { UsePersonalInfoReturnType } from "../../hooks/usePersonalInfo";
import { Token } from "../../theme";

export const DrataIdentifier = () => {
  const { user, selfRegenerateDrataIdentifier } = useContext<UsePersonalInfoReturnType>(PersonalInformationContext);
  const handleCopy = async () => {
    try {
      if (user.drataIdentifier) {
        await navigator.clipboard.writeText(user.drataIdentifier);
        NotificationService.info("Copied Identifier to Clipboard!");
      } else {
        throw new Error("Could Not Copy Identifier to Clipboard");
      }
    } catch (err) {
      const message = err.message || "Unknown Error";
      NotificationService.error(message);
    }
  };

  return (
    <OpsPanel title="Drata Identifier" svg={drataIdentifierIconSVG}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            padding: "8px 12px",
            border: `1px solid ${Token.borderDefault}`,
            borderRadius: `${Token.radiusControl}`,
            backgroundColor: Token.surfaceSunken,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              flex: 1,
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              color: !user.drataIdentifier ? Token.statusDangerFg : Token.textPrimary,
              fontFamily: "var(--font-mono)",
              fontSize: "12.5px",
            }}
          >
            {user.drataIdentifier || "Drata Identifier Not Found"}
          </Typography>
          <IconButton size="small" disabled={!user.drataIdentifier} aria-label="Copy" onClick={handleCopy} sx={{ flexShrink: 0 }}>
            <ContentCopyIcon fontSize="small" color={user.drataIdentifier ? "primary" : "disabled"} />
          </IconButton>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2 }}>
          <Typography fontSize="11.5px" color={Token.textTertiary}>
            Regenerating invalidates the old identifier.
          </Typography>
          <DebounceButton
            onClick={selfRegenerateDrataIdentifier}
            text="Regenerate"
            ms={1000}
            variant="outlined"
            size="small"
            sx={{
              color: Token.textPrimary,
              borderColor: Token.borderDefault,
              backgroundColor: Token.surfaceRaised,
              flexShrink: 0,
              textTransform: "none",
              "&:hover": {
                borderColor: Token.borderStrong,
                backgroundColor: Token.surfaceHover,
              },
            }}
          />
        </Box>
      </Box>
    </OpsPanel>
  );
};
